import { styled } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";

export const StyledDraggableBox = styled(Box, {
  shouldForwardProp: (prop) =>
    !["isDragging", "draggableStyle"].includes(prop),
})(({ theme, isDragging, draggableStyle }) => ({
  backgroundColor: theme.palette.hubColors.white,
  width: "100%",
  borderRadius: "10px",
  zIndex: 1,
  ...draggableStyle,
  ...(isDragging && {}),
}));

export const StyledDroppableStack = styled(Stack)({
  position: "relative",
  gap: "0px",
});

export const StyledPlaceholderDiv = ({ placeholderProps, disabled = false }) =>
  placeholderProps && !disabled
    ? {
        position: "absolute",
        top: placeholderProps.clientY,
        left: 0,
        right: 0,
        height: placeholderProps.clientHeight,
        width: placeholderProps.clientWidth,
        boxSizing: "border-box",
        borderRadius: "4px",
        border: "1px dashed",
        borderColor: "rgba(0, 122, 253, 1)",
        backgroundColor: "rgba(0, 122, 253, 0.08)",
        zIndex: 0,
      }
    : { display: "none" };
